import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { CustomNotificationService } from "../../services/custom-notification.service";
import { AuthenticationService } from "../../services/authentication.service";
import { LucideAngularModule } from "lucide-angular";

@Component({
  selector: "app-forgot-password",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    LucideAngularModule,
  ],
  templateUrl: "./forgot-password.component.html",
  styleUrl: "./forgot-password.component.css",
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  loading = false;
  submitted = false;
  emailSent = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private notificationService: CustomNotificationService,
    private authService: AuthenticationService,
  ) {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {}

  get f() {
    return this.forgotPasswordForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.loading = true;
    const email = this.f["email"].value;

    this.authService.generateResetPasswordEmail(email).subscribe({
      next: () => {
        this.emailSent = true;
        this.loading = false;
        this.notificationService.success(
          "Reset Email Sent",
          "Check your email for password reset instructions.",
        );
      },
      error: (error: any) => {
        console.error("Error sending reset email:", error);
        this.emailSent = true;
        this.loading = false;
        this.notificationService.info(
          "Reset Email Sent",
          "If an account with this email exists, you will receive password reset instructions.",
        );
      },
    });
  }

  goBackToLogin(): void {
    this.router.navigate(["/login"]);
  }

  resendEmail(): void {
    this.emailSent = false;
    this.submitted = false;
    this.loading = false;
  }
}
